import Vue from 'vue'
import Vuetify from 'vuetify'
import ja from 'vuetify/src/locale/ja'

Vue.use(Vuetify, {
  theme: {
    info: '#3C763D',
    warning: '#C95E7D'
  }
})

export default new Vuetify({
  lang: {
    locales: { ja },
    current: 'ja'
  }
})
